import React from 'react';
import { AnimatedIcon } from '@shell-b2c/web-design-system';

export const SandWatchAnimation = (props) => {
  return <AnimatedIcon type="sand-watch" {...props} />;
};

export default SandWatchAnimation;
